import { SearchableCandidateBatchFilterInput } from 'generated-graphql/types';
import { buildTextSearchClauses } from 'utils/buildTextSearchClauses';

/**
 * The OR clauses used to search analyses by free text. Shared by the Analyses
 * tab and the campaign-creation choose-analysis picker so both cover the same
 * fields. Callers slot the result into their own filter (top-level `or` vs an
 * `and` array).
 */
export const buildAnalysisSearchClauses = (
  searchText: string
): SearchableCandidateBatchFilterInput[] => [
  ...buildTextSearchClauses('title', searchText),
  { atsJobReference: { matchPhrasePrefix: searchText } },
  { atsJobId: { matchPhrasePrefix: searchText } }
];
